// Copyright (c) 2016 Deere & Company

import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import moment from 'moment';
import t from 'tcomb';

const PipSearchResult = t.struct({
    comments: t.String,
    daysRemaining: t.Number,
    description: t.String,
    dtac: t.String,
    dtacUrl: t.String,
    expireDate: t.Number,
    internalRecall: t.String,
    metric: KeyValuePair,
    participant: KeyValuePair,
    pipId: t.String,
    pipNumber: t.String,
    pipStatus: KeyValuePair,
    pipType: KeyValuePair,
    startDate: t.maybe(t.Number),
    terminationDate: t.Number
}, {
    name: 'PipSearchResult',
    strict: true
});

export const getDefaultState = () => new PipSearchResult({
    comments: '',
    daysRemaining: 0,
    description: '',
    dtac: '',
    dtacUrl: '',
    expireDate: moment().utc().unix(),
    internalRecall: '',
    metric: getKeyValuePairDefaultState(),
    participant: getKeyValuePairDefaultState(),
    pipId: '',
    pipNumber: '',
    pipStatus: getKeyValuePairDefaultState(),
    pipType: getKeyValuePairDefaultState(),
    startDate: null,
    terminationDate: moment().utc().unix()
});

export default PipSearchResult;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/pip-search-results.js